import { render, staticRenderFns } from "./dubbingList.vue?vue&type=template&id=57cb9028&scoped=true"
import script from "./dubbingList.vue?vue&type=script&lang=js"
export * from "./dubbingList.vue?vue&type=script&lang=js"
import style0 from "./dubbingList.vue?vue&type=style&index=0&id=57cb9028&prod&scoped=true&lang=scss"
import style1 from "./dubbingList.vue?vue&type=style&index=1&id=57cb9028&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cb9028",
  null
  
)

export default component.exports